/**
 * DropDown listens on document for outside clicks. Autocomplete suggestion
 * handlers also run on document (React 16 delegation), so stopPropagation
 * cannot prevent DropDown from seeing the same click. Briefly suppress
 * outside-close while a suggestion is being chosen.
 */
let suppressUntil = 0;

export function suppressDropdownOutsideClick(ms = 750) {
  suppressUntil = Date.now() + ms;
}

export function isDropdownOutsideClickSuppressed() {
  return Date.now() < suppressUntil;
}
